import * as constants from '../constants';

const initialState = {
};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case constants.createRecommendationRegistry.success: {
            return action.payload;
        }

        case constants.createRecommendationRegistry.try:
        case constants.createRecommendationRegistry.error: {
            return initialState;
        }

        default:
            return state;
    }
}
